export default "__VITE_ASSET__BP1krEQS__"